import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
  accepted: attr('boolean'),
  acceptedAt: attr('date'),
  createdAt: attr('date'),
  updatedAt: attr('date'),

  // relationships
  legal: belongsTo('legal', { async: false }),
  related: belongsTo('shModel', { async: false, polymorphic: true})
});
